var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    "component",
    "component__status",
    ("component__status--" + (_vm.toKebabCase(_vm.status))),
    _vm.size ? ("component__status--" + _vm.size) : '',
    _vm.type ? ("component__status--" + _vm.type) : '',
    _vm.forceDefault ? "component__status--force-default" : '',
    _vm.forceSuccess ? "component__status--force-success" : '',
    _vm.forceInfo ? "component__status--force-info" : '',
    _vm.forceDanger ? "component__status--force-danger" : '' ]},[_vm._v(_vm._s(_vm._f("toCapitalize")(_vm._f("fromKebabCaseToString")(_vm.status))))])}
var staticRenderFns = []

export { render, staticRenderFns }